import { Component } from '@angular/core';
import { LaunchDialogService, IconComponent } from '@spartacus/storefront';
import { ICON_TYPE } from '../../model/external-catalogs-enum.model';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-topmotive-confirmation-dialog',
    templateUrl: './topmotive-confirmation-dialog.component.html',
    imports: [IconComponent, TranslatePipe]
})
export class TopmotiveConfirmationDialogComponent {

  iconTypes = ICON_TYPE;

  constructor(private launchDialogService: LaunchDialogService) {}

  confirm(): void {
    this.closeModal('confirmed');
  }
  
  closeModal(status: string = 'closed'): void {
    this.launchDialogService.closeDialog(status);
  }
}
